<oo-form-filler (afterSave)="onSave()"
                [dataFetcher]="state.dataFetcher"
                [isSubmissionMode]="true"
                [onSubmitCallback]="state.dataSaver">
</oo-form-filler>
